import { observer } from 'mobx-react';
import React, { useEffect } from 'react';
import './StatsPage.scss';
import { formatCurrencyAmount } from '../../helpers/formatters';
import { statsStore } from '../../stores/StatsStore';
import { LWChart } from '../LWChart/LWChart';
import dayjs from 'dayjs';

const StatsPage = observer(() => {

    useEffect(() => {
        statsStore.fetchSummaryStats();
        statsStore.fetchUsersStats();
        statsStore.fetchTxsStats();
        statsStore.fetchVolumeStats();
    }, []);

    return (<div className="StatsPage">
        <h1 className="nereus-h4-m nereus-color-main">Stats</h1>
        <p className="mt-2 mb-6 nereus-color-neutral-grey nereus-body">Explore Nereus Total Stats since {dayjs(statsStore.volumeStatsForChart[0]?.time)?.format('MMMM D YYYY') || ''}.</p>

        <div className="flex justify-between nereus-body-m mt-10 mb-4"><span>Total Volume</span><span>{statsStore?.summary?.totalVolume
            ? formatCurrencyAmount(statsStore?.summary?.totalVolume, '$')
            : ''}</span></div>
        <LWChart data={statsStore.volumeStatsForChart} />
        <div className="flex justify-between nereus-body-m mt-10 mb-4"><span>Total Transactions</span><span>{statsStore?.summary?.totalTxs ? statsStore.summary?.totalTxs : ''}</span></div>
        <LWChart data={statsStore.transactionStatsForChart} accentColor='#00E0FF' />
        <div className="flex justify-between nereus-body-m mt-10 mb-4"><span>Unique Users</span><span>{statsStore?.summary?.totalUsers ? statsStore?.summary?.totalUsers : ''}</span></div>
        <LWChart data={statsStore.userStatsForChart} accentColor='#6000DB' />
    </div>);
})

export default StatsPage;
